import { render, staticRenderFns } from "./leifeng-setting.vue?vue&type=template&id=3b354b1a&scoped=true&"
import script from "./leifeng-setting.vue?vue&type=script&lang=js&"
export * from "./leifeng-setting.vue?vue&type=script&lang=js&"
import style0 from "./leifeng-setting.vue?vue&type=style&index=0&id=3b354b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b354b1a",
  null
  
)

export default component.exports